import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ListadoMaterias.css';
import CalificadorSIGEDI from './CalificadorSIGEDI';

const ListadoMaterias = ({ instancia }) => {
  const [materias, setMaterias] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const [materiaActiva, setMateriaActiva] = useState(null);
  const [divisionSeleccionada, setDivisionSeleccionada] = useState(null);

  const normalizarTexto = (valor = '') =>
    String(valor || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

  const esFinal = (valor) => {
    return normalizarTexto(valor).includes('final');
  };

  const obtenerExclusivoJSON = (valor) => {
    if (!valor) return null;

    if (esFinal(valor)) {
      return null;
    }

    try {
      return typeof valor === 'string' ? JSON.parse(valor) : valor;
    } catch (error) {
      console.error('Error parseando exclusivo:', error, valor);
      return null;
    }
  };

  const obtenerMaterias = async () => {
    if (!instancia) return;

    setCargando(true);
    setError('');

    try {
      const response = await axios.post(
        'https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveMateriasPorCurso',
        { curso: instancia.nombreCurso }
      );

      let materiasObtenidas = response.data.materias || [];

      const exclusivoJSON = obtenerExclusivoJSON(instancia.exclusivo);

      if (exclusivoJSON) {
        materiasObtenidas = materiasObtenidas.filter(
          (m) => exclusivoJSON[m.id]
        );
      }

      setMaterias(materiasObtenidas);
    } catch (err) {
      setError('Error al obtener materias');
      console.error(err);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    obtenerMaterias();
  }, [instancia]);

  const toggleMateria = (id) => {
    setMateriaActiva(materiaActiva === id ? null : id);
  };

  const abrirModalDivision = (division) => {
    setDivisionSeleccionada(division);
  };

  const cerrarModal = () => {
    setDivisionSeleccionada(null);
  };

  if (!instancia?.nombreCurso) {
    return <p className="lm-alert">⚠️ No se especificó un curso.</p>;
  }

  if (cargando) return <p className="lm-info">Cargando materias...</p>;
  if (error) return <p className="lm-error">{error}</p>;

  return (
    <div className="lm-container">
      <h4 className="lm-title">
        Materias de asdasdasda {instancia.nombreCurso}
      </h4>

      {esFinal(instancia.exclusivo) && (
        <div className="alert alert-info py-2">
          Instancia final: se muestran todas las materias para calificar.
        </div>
      )}

      <div className="lm-accordion">
        {materias.map((materia) => (
          <div className="lm-accordion-item" key={materia.id}>
            <div
              className={`lm-accordion-header ${
                materiaActiva === materia.id ? 'active' : ''
              }`}
              onClick={() => toggleMateria(materia.id)}
            >
              {materia.nombreMateria}

              <span className="lm-chevron">
                {materiaActiva === materia.id ? '▲' : '▼'}
              </span>
            </div>

            {materiaActiva === materia.id && (
              <div className="lm-accordion-body">
                {materia.asignaciones?.length > 0 ? (
                  <div className="lm-list">
                    {materia.asignaciones.map((div, idx) => (
                      <div
                        key={idx}
                        className="lm-list-item"
                        onClick={() => abrirModalDivision(div)}
                      >
                        📌 División {div.division} – {div.sedeCursada}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="lm-empty">
                    No hay divisiones asignadas
                  </p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      {divisionSeleccionada && (
        <div className="lm-modal-backdrop">
          <div className="lm-modal lm-modal-large">
            <div className="lm-modal-header">
              <h5>
                División {divisionSeleccionada.division}
              </h5>

              <button className="lm-close" onClick={cerrarModal}>
                ✖
              </button>
            </div>

            <div className="lm-modal-body">
              <CalificadorSIGEDI
                aulaID={divisionSeleccionada.division}
                idAsignacionMateria={divisionSeleccionada}
                idInstancia={{
                  ...instancia,
                  exclusivo: esFinal(instancia.exclusivo)
                    ? null
                    : instancia.exclusivo,
                  esFinal: esFinal(instancia.exclusivo),
                }}
                idCurso={divisionSeleccionada.idCurso}
                cierro={() => cerrarModal()}
              />
            </div>

            <div className="lm-modal-footer">
              <button className="lm-btn-secondary" onClick={cerrarModal}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListadoMaterias;